export const BaseExternalUrls = {
  DPA_PSP: 'https://stazzle.de/stazzle-avv/',
};
